import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative w-full overflow-hidden" data-id="element-83">
      <img src="https://cdn.magicpatterns.com/uploads/jmJc2UJ9cYGQk4FcJUJJm3/heylloyd-image-1773669100538.png" alt="RÔA Imported — Bolsos, zapatillas, accesorios y más" className="w-full object-cover" style={{
      minHeight: '500px'
    }} data-id="element-84" />

      {/* Overlay content */}
      <div className="absolute inset-0 flex items-end justify-center pb-8 md:pb-14" data-id="element-85">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: [0.25, 0.46, 0.45, 0.94]
      }} data-id="element-86">
          <button onClick={e => {
          e.preventDefault();
          const target = document.getElementById('coleccion');
          if (target) {
            target.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        }} className="border-2 border-white/70 bg-transparent px-[50px] py-4 text-[12px] uppercase tracking-[4px] text-[#1a1a1a] no-underline backdrop-blur-sm transition-all duration-300 hover:border-[#1a1a1a] hover:bg-[#1a1a1a] hover:text-white" data-id="element-87">
            Ver Colección
          </button>
        </motion.div>
      </div>
    </section>;
}